<template>
    <div>
        <p class="text-center mb-0">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>
        <p class="text-center"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
        
        <b-alert variant="danger" :show="dados.QtdDiasInternado < 7 ? true : false" class="text-center mt-2">
            <strong>Atenção:</strong> paciente não possui mais de 7 dias de internação
        </b-alert>

        <div class="row">
            <div class="col-sm-12 form-group">
                 <label>Nome</label>
                 <input class="form-control" :value="dados.pacienteNome" disabled>
            </div>
        </div>

         <div class="row">
             <div class="col-sm-3 form-group">
                 <label>CNS</label>
                 <input class="form-control" :value="dados.pacienteCns" disabled>
            </div>

            <div class="col-sm-3 form-group">
                <label>Sexo</label>
                <select type="text" class="form-control" :value="dados.pacienteSexo"  disabled>
                    <option value="1">Masculino</option>
                    <option value="2">Feminino</option>
                </select>
            </div>

             <div class="col-sm-4 form-group">
                 <label>Data de Nascimento</label>
                 <input class="form-control" :value="dados.pacienteDataNascimento" disabled>
            </div>

             <div class="col-sm-2 form-group">
                <label>Idade</label>
                <input class="form-control" :value="dados.pacienteIdade" disabled>
            </div>
        </div>


        <div class="row">
            <div class="col-sm-3 form-group">
                <label>Data/Hora Internação</label>
                <input class="form-control" :value="dados.DataHoraInternacao" disabled>
            </div>

            <div class="col-sm-3 form-group">
                <label>Qtd. Dias internado</label>
                <input class="form-control" :value="dados.QtdDiasInternado" disabled>
            </div>

            <div class="col-sm-6 form-group">
                <label>Categoria</label>
                <select class="form-control" v-model="IdCategoria">
                    <option value="" selected disabled>Selecione</option>
                    <option v-for="(item, index) in categorias" :key="index" :value="item.id">{{item.nome}}</option>
                </select>
            </div>
        </div>

        <div v-if="IdCategoria == 1" class="bordas">
            <div class="row">
                <div class="col-sm-3 form-group">
                    <label to="data-picker">Data da Alta Médica</label>
                    <datepicker
                        v-model="data_alta_semformatacao"
                        :format="formatoData"
                        :disabled="dateDisabled"
                        language="pt-br"
                        id="data-picker"
                        calendar-button
                        calendar-button-icon="fa fa-calendar"
                        >
                    </datepicker>
                    <small v-if="data_alta_semformatacao == ''" class="text-danger">preenchimento obrigatório</small>
                </div>

                <div class="col-sm-9 form-group">
                    <label>Responsável pela Alta Clínica</label>
                    <input class="form-control text-uppercase" v-model="casoSocial.responsavelAltaClinica">
                    <small v-if="casoSocial.responsavelAltaClinica == ''" class="text-danger">preenchimento obrigatório</small>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-3 form-group">
                    <label>Índice de Barthel</label>
                    <div class="input-group mb-3">
                        <input class="form-control" disabled :value="casoSocial.indiceBarthel">
                        <div class="input-group-append">
                            <button class="btn btn-outline-primary plano" @click="mostrabartel = true">Calcular</button>
                        </div>
                    </div>
                    <small v-if="casoSocial.indiceBarthel == ''" class="text-danger">preenchimento obrigatório</small>                
                </div>
            </div>

            <barthel v-if="mostrabartel" @contabilidadeBarthel="contabiliza" />

            <div class="row">
                <div class="form-group col-sm-12">
                    <label for="unidade">Unidade de Procedência</label>
                    <multiselect
                        :options="listaUnidades"
                        track-by="nome"
                        label="nome"
                        :searchable="true"
                        placeholder="Pesquise e selecione"
                        selectLabel="+"
                        deselectLabel="-" 
                        selectedLabel="selecionado"
                        v-model="casoSocial.unidadeProcedencia"
                        >

                        <span slot="noResult">Nenhum resultado encontrado.</span>
                    </multiselect>
                    <small v-if="casoSocial.unidadeProcedencia == null || casoSocial.unidadeProcedencia == ''" class="text-danger">preenchimento obrigatório</small>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-sm-6">
                    <label for="unidade">CID Primário</label>
                    <multiselect
                        :options="listaCid"
                        track-by="cid"
                        label="cid"
                        :searchable="true"
                        placeholder="Pesquise e selecione"
                        selectLabel="+"
                        deselectLabel="-" 
                        selectedLabel="selecionado"
                        v-model="casoSocial.cidp"
                        >

                        <span slot="noResult">Nenhum resultado encontrado.</span>
                    </multiselect>
                    <small v-if="casoSocial.cidp == null" class="text-danger">preenchimento obrigatório</small>
                </div>

                <div class="form-group col-sm-6">
                    <label for="unidade">CID Secundário</label>
                    <multiselect
                        :options="listaCid"
                        track-by="cid"
                        label="cid"
                        :searchable="true"
                        placeholder="Pesquise e selecione"
                        selectLabel="+"
                        deselectLabel="-" 
                        selectedLabel="selecionado"
                        v-model="casoSocial.cids"
                        >

                        <span slot="noResult">Nenhum resultado encontrado.</span>
                    </multiselect>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 form-group">
                    <label>Família localizada?</label>
                    <select class="form-control" v-model="casoSocial.familiaLocalizada">
                        <option value="" selected disabled>Selecione</option>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </select>
                    <small v-if="casoSocial.familiaLocalizada == ''" class="text-danger">preenchimento obrigatório</small>        
                </div>

                <div class="col-sm-6 form-group">
                    <label>Tipo de Moradia</label>
                    <select class="form-control" v-model="casoSocial.tipoMoradia">
                        <option value="" selected disabled>Selecione</option>
                        <option value="Abrigo">Abrigo</option>
                        <option value="População de Rua">População de Rua</option>
                        <option value="Residência Própria">Residência Própria</option>
                    </select>
                    <small v-if="casoSocial.tipoMoradia == ''" class="text-danger">preenchimento obrigatório</small>        
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 form-group">
                    <label>Apresenta histórico de saúde mental?</label>
                    <select class="form-control" v-model="casoSocial.historicoSaudeMental">
                        <option value="" selected disabled>Selecione</option>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </select>
                    <small v-if="casoSocial.historicoSaudeMental == ''" class="text-danger">preenchimento obrigatório</small>
                </div>
            </div>
        </div>

        <div class="bordas" v-if="IdCategoria != 1 && IdCategoria != ''" >
            <div class="row">
                <div class="form-group col-sm-12">
                    <label for="obss">Observações</label>
                    <textarea class="form-control text-uppercase" id="obss" rows="4" v-model="outros.observacao"></textarea>
                    <small v-if="outros.observacao == ''" class="text-danger">preenchimento obrigatório</small>
                </div>
            </div>
        </div>


        <button v-if="IdCategoria != ''" type="button" class="btn btn-primary" @click="validaSessao('notificar')">Notificar Longa Permanência</button>
    </div>
</template>

<script>
import Barthel from './barthel/Barthel.vue'
import Datepicker from 'vuejs-datepicker'
import moment from "moment"
import { validaSessao } from '../../../shared/mixins/validaSessao'

export default {
    props: {
        dados: Object
    },
    mixins: [
        validaSessao
    ],
    components: {
        Barthel,
        Datepicker
    },
    mounted () {
        this.desabilitaDatas()
    },
    data () {
        return {
            mostrabartel: false,
            IdCategoria: '',
            formatoData: 'dd/MM/yyyy',
            data_alta_semformatacao: '',
            dateDisabled: {
                ranges: [
                    {
                        from: new Date(1990, 11, 25),
                        to: new Date(1990, 11, 25)
                    },
                    {
                        from: new Date(),
                        to: new Date(2040, 2, 25)
                    }
                ]
            },

            casoSocial: {
                responsavelAltaClinica: '',
                indiceBarthel: '',
                cidp: null,
                cids: null,
                unidadeProcedencia: '',
                familiaLocalizada: '',
                tipoMoradia: '',
                historicoSaudeMental: ''
            },
            outros: {
                observacao: ''
            }
        }
    },
    computed: {
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
        categorias () {
            return this.$store.getters['longapermanencia/getCategoriasLp']
        },
        listaCid () {
            return this.$store.getters['consultas/getListaCid']
        },
        listaUnidades () {
            return this.$store.getters['longapermanencia/getUnidadesProcedenciaLP']
        },
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
    },
    methods: {
        formatadata (date) {
            return moment(date).format("YYYY-MM-DD")
        },
        desabilitaDatas () {
            if (this.dados.DataHoraInternacao !== null && this.dados.DataHoraInternacao !== '') {
                let ultimaMovimentacao = this.dados.DataHoraInternacao
                let dia = parseInt(ultimaMovimentacao.substr(0,2))
                let mes = parseInt(ultimaMovimentacao.substr(3,2)) - 1
                let ano = parseInt(ultimaMovimentacao.substr(6,4))

                this.dateDisabled.ranges[0]['to'] = new Date(ano, mes,dia)
            }
        },
        contabiliza (value) {
            this.mostrabartel = false
            this.casoSocial.indiceBarthel = value
        },
        notificar () {
            if (this.IdCategoria == '1') {
                if (
                        this.casoSocial.responsavelAltaClinica == ''  ||
                        this.casoSocial.indiceBarthel == ''           ||
                        this.casoSocial.cidp == null                  ||
                        this.casoSocial.unidadeProcedencia == ''      ||
                        this.casoSocial.unidadeProcedencia == null    ||
                        this.casoSocial.familiaLocalizada == ''       ||
                        this.casoSocial.tipoMoradia == ''             ||
                        this.casoSocial.historicoSaudeMental == ''    
                ) return

                let dados = {
                    responsavelAltaClinica: this.casoSocial.responsavelAltaClinica.toUpperCase(),
                    indiceBarthel: this.casoSocial.indiceBarthel,
                    cidp: this.casoSocial.cidp.cid.substr(0,4),
                    cids: '',
                    unidadeProcedencia: this.casoSocial.unidadeProcedencia.cnes,
                    dataClinica: this.formatadata(this.data_alta_semformatacao),
                    idCategoriaLongaPermanencia: this.IdCategoria,
                    idInternacao: this.dados.internacaoId,
                    cnes: this.unidadeSelecionada.cnes,
                    familiaLocalizada: this.casoSocial.familiaLocalizada,
                    tipoMoradia: this.casoSocial.tipoMoradia,
                    historicoSaudeMental: this.casoSocial.historicoSaudeMental
                }
                if (this.casoSocial.cids != null && this.casoSocial.cids != '') dados.cids = this.casoSocial.cids.cid.substr(0,4)


                this.$emit('notifica', dados)
            }

            if (this.IdCategoria != '1' && this.IdCategoria != '') {
                if (this.outros.observacao == '') return

                let dados = {
                    idCategoriaLongaPermanencia: this.IdCategoria,
                    idInternacao: this.dados.internacaoId,
                    cnes: this.unidadeSelecionada.cnes,
                    observacao: this.outros.observacao.toUpperCase()
                }
               
                this.$emit('notifica', dados)
            }
        }
    }
}
</script>